export default __webpack_public_path__ + "static/media/kh.66413c8d.svg";